module.exports = __webpack_public_path__ + "img/bandaoti_meiguang_suoluetu.414329b2.png";